import moment from 'moment';
import {
  BrushSelectType,
  IRealtimeStreamingDetail,
  LiveTimeType,
} from '../type';
import { DBO_TM } from '@op/utils/format';

export function formatStreamingTime(value: string) {
  try {
    const items = value.split(':');

    return `${items[0]}:${items[1]}`;
  } catch (error) {
    return value;
  }
}

export function formatChartResult(
  data: [
    { time: string; playback_time: string },
    { time: string; playback_time: string },
  ],
): BrushSelectType {
  const [startData, endData] = data;
  return {
    filter: {
      start_time: startData.time,
      end_time: endData.time,
    },
    liveTime: {
      startTime: formatStreamingTime(startData.playback_time),
      endTime: formatStreamingTime(endData.playback_time),
    },
  };
}

export function getLiveTimeTitle(liveTime?: LiveTimeType) {
  if (!liveTime) return '-';
  return `${liveTime.startTime} ~ ${liveTime.endTime}`;
}

function formatTimeToNearest5Minutes(duration: number): string {
  const durationValue = moment.duration(duration, 'seconds');
  const hours = durationValue.hours();
  const minutes = durationValue.minutes();
  const roundedMinutes = minutes < 5 ? 0 : Math.floor(minutes / 5) * 5;
  return `${hours}:${String(roundedMinutes).padStart(2, '0')}`;
}


/**
 * 通过live time 和 live duration 获取过滤器时间
 * @param data 
 * @returns 
 */
export function getLiveTimeFilter(data?: IRealtimeStreamingDetail) {
  // 这里设置不能超过23小时55分钟,因为过滤器无法设置超出这个时间的数据
  const durationOri = data?.live_duration || 0;
  const duration = durationOri > 86100 ? 86100 : durationOri;

  const startTime = data?.live_time;
  const endTimeValue = formatTimeToNearest5Minutes(duration);

  return {
    liveTime: {
      startTime: '00:00',
      endTime: endTimeValue,
    },
    filter: {
      start_time: startTime,
      end_time: startTime ? DBO_TM.add(startTime, endTimeValue) : undefined,
    },
  };
}
